// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2O9Ht","field":"styles_field__37_oX","fieldCol":"styles_fieldCol__2W76r","diffCol":"styles_diffCol__20ys0","diff":"styles_diff__3yeRG"};